module.exports = __webpack_public_path__ + "img/frame_6_icon.aaf3ad52.png";